import React from 'react'

import Card from '../../../../../components/Card'

import * as S from './styles'

function LoadingCards ({ limit = 5 }) {
  return (
    <S.WrapperCards>
      {Array(limit).fill().map((item, index) => <S.StyledCard key={index}><Card loading skeletonHeight={120} /></S.StyledCard>)}
    </S.WrapperCards>
  )
}

export default LoadingCards
